import { OptionsItem } from '../../../services/common/miscUtils.types';

export enum DistributionModels {
  'Classic' = 'NA',
  'AgencyModel' = `BEV`,
  'FleetAgency' = 'FEV',
}

export const distributionModelsOptionsPrivate: Array<OptionsItem<DistributionModels>> = [
  { value: DistributionModels.Classic, label: 'Distribution classique' },
  { value: DistributionModels.AgencyModel, label: `Modéle d'agence` },
];

export const distributionModelsOptionsBusiness: Array<OptionsItem<DistributionModels>> = [
  { value: DistributionModels.Classic, label: 'Distribution classique' },
  { value: DistributionModels.AgencyModel, label: `Modéle d'agence` },
  { value: DistributionModels.FleetAgency, label: 'Fleet Agency' },
];
